module.exports = __webpack_public_path__ + "static/media/brand3-small.21db3c44.jpg";